import { render, staticRenderFns } from "./AreaProjectSet.vue?vue&type=template&id=9b0360da"
import script from "./AreaProjectSet.vue?vue&type=script&lang=js"
export * from "./AreaProjectSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports